import React from 'react';
import { SetComponentLanguage } from '../../../helpers';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

const CountryOptions = () => {
    return (
        strings.countries.map((country, i) => <option key={i} value={country.abbreviation}>{country.name}</option>)
    )
}

export default CountryOptions;


// WEBPACK FOOTER //
// ./src/components/Common/CountryOptions/CountryOptions.js